import React, { useState, useEffect } from "react";
import {
  TextField,
  CircularProgress,
  List,
  ListItem,
  Paper,
  Box,
} from "@mui/material";

type Option = { id: number; businessName: string };

type Props = {
  placeholder?: string;
  fetchOptions: (query: string) => Promise<Option[]>;
  formik: any;
  idField: string;
  labelField: string;
};

function AutoSuggestions({
  placeholder = "Search...",
  fetchOptions,
  formik,
  idField,
  labelField,
}: Props) {
  const [inputValue, setInputValue] = useState(formik.values[labelField] || "");
  const [options, setOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  useEffect(() => {
    setInputValue(formik.values[labelField] || "");
  }, [formik.values[labelField]]);
  useEffect(() => {
    if (!inputValue) {
      setOptions([]);
      return;
    }

    const handler = setTimeout(async () => {
      setLoading(true);
      try {
        const results = await fetchOptions(inputValue);
        setOptions(results);
      } finally {
        setLoading(false);
      }
    }, 300);

    return () => clearTimeout(handler);
  }, [inputValue, fetchOptions]);

  const handleSelect = (item: Option) => {
    formik.setFieldValue(idField, item.id);
    formik.setFieldValue(labelField, item.businessName);

    setInputValue(item.businessName);
    setShowDropdown(false);
  };

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <TextField
        fullWidth
        size="small"
        placeholder={placeholder}
        value={inputValue}
        onChange={(e) => {
          const value = e.target.value;
          setInputValue(value);
          setShowDropdown(true);
          if (!value) {
            formik.setFieldValue(idField, undefined);
            formik.setFieldValue(labelField, "");
          }
        }}
        onBlur={() => {
          setTimeout(() => setShowDropdown(false), 150);
        }}
      />

      {showDropdown && inputValue && (
        <Paper sx={{ position: "absolute", zIndex: 10, width: "100%" }}>
          <List disablePadding>
            {loading ? (
              <ListItem>Loading...</ListItem>
            ) : options.length === 0 ? (
              <ListItem>
                {idField === "providerIds"
                  ? "No providers found"
                  : "No planners found"}
              </ListItem>
            ) : (
              options.map((item) => (
                <ListItem
                  key={item.id}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleSelect(item);
                  }}
                  sx={{ cursor: "pointer" }}
                >
                  {item.businessName}
                </ListItem>
              ))
            )}
          </List>
        </Paper>
      )}
    </Box>
  );
}

export default AutoSuggestions;
